// src/Pages/Home/TrendFashion/sections/PremiumCategoriesFashionSection.tsx
import React, { useMemo } from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import type { StoreSection } from "../../../../redux/services/store/storePagesApi";

type Props = {
  section: StoreSection;
};

type Tile = {
  slot?: string | null;
  sort_order?: number | null;
  content_json?: any;
};

const PremiumCategoriesFashionSection: React.FC<Props> = ({ section }) => {
  const header = (section.settings_json?.header || {}) as any;
  const styles = (section.settings_json?.styles || {}) as any;
  const items = (section.items || []) as Tile[];

  const tiles = useMemo(() => {
    const order = ["main", "a", "b", "c", "d"];
    const map: Record<string, any> = {};

    for (const it of items) {
      const slot = String(it.slot || "").trim();
      if (!slot) continue;
      map[slot] = it.content_json || {};
    }

    return order
      .map((slot) => ({ ...map[slot], _slot: slot }))
      .filter((x) => x && (x.image_url || x.label || x.link));
  }, [items]);

  const tileCard = (tile: any) => {
    const img = tile?.image_url || "";
    const label = tile?.label || "View";
    const link = tile?.link || "#";

    return (
      <Link to={link} className="text-decoration-none d-block h-100">
        <div
          className="category-widgets-main card border-0 shadow-none bg-light h-100"
          style={{
            borderRadius: "16px",
            overflow: "hidden",
          }}
        >
          <div
            className="effect position-relative overflow-hidden"
            style={{
              aspectRatio: "3 / 4",
              minHeight: "380px",
            }}
          >
            {img ? (
              <img
                src={img}
                alt={label}
                className="w-100 h-100 d-block object-fit-cover"
                style={{ objectPosition: "top center" }}
              />
            ) : (
              <div className="d-flex align-items-center justify-content-center text-muted w-100 h-100">
                No image
              </div>
            )}

            <div
              className="position-absolute top-0 start-0 w-100 h-100"
              style={{
                background:
                  "linear-gradient(to top, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.18) 35%, rgba(0,0,0,0.02) 60%, rgba(0,0,0,0) 100%)",
              }}
            />

            <div
              className="position-absolute start-0 bottom-0 w-100"
              style={{ padding: "18px" }}
            >
              <div
                className="text-white"
                style={{
                  fontSize: "1rem",
                  fontWeight: 600,
                  lineHeight: 1.2,
                  marginBottom: "10px",
                  textShadow: "0 1px 4px rgba(0,0,0,0.25)",
                }}
              >
                {label}
              </div>

              <span
                className="d-inline-flex align-items-center justify-content-center"
                style={{
                  background: "rgba(255,255,255,0.95)",
                  color: "#111",
                  padding: "8px 14px",
                  borderRadius: "999px",
                  fontSize: "0.88rem",
                  fontWeight: 600,
                  lineHeight: 1,
                }}
              >
                Shop Now
              </span>
            </div>
          </div>
        </div>
      </Link>
    );
  };

  return (
    <section>
      <div className={styles.container_class || "container-fluid container-custom"}>
        <Row className="justify-content-center">
          <Col lg={7}>
            <div className="section-content text-center mb-5">
              {header.kicker ? (
                <p className={styles.kicker_class || "fs-20"}>{header.kicker}</p>
              ) : null}

              <h2
                className={styles.title_class || "title fw-normal text-capitalize"}
                dangerouslySetInnerHTML={{ __html: header.title_html || "" }}
              />
            </div>
          </Col>
        </Row>

        <Row className="g-4">
          {tiles.map((tile: any, idx: number) => (
            <Col key={`${tile._slot || "tile"}-${idx}`} xl={3} lg={4} md={6} xs={12}>
              {tileCard(tile)}
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
};

export default PremiumCategoriesFashionSection;